<template>
  <div class="custom-footer container-fluid text-white py-4 py-lg-5">
    <div class="container">
      <div class="col-lg-12 container">
        <div class="row">
          <div class="col-lg-4 mb-4 mb-lg-0">
            <h5 class="font-bold">Get in touch</h5>
            <div>
              <b>Address:</b>
              <p class="mb-3">
                ALIFF OVERSEAS, 203, God’s Gift Tower, Next To Lucky Hotel, S.V.
                Road, Bandra (West), Mumbai – 400050, India
              </p>
              <div class="d-flex justify-content-between align-items-center">
                <span>
                  <img
                    src="@/assets/imgs/franchise/Phone.svg"
                    class="locator_pointer_img"
                    style="mix-blend-mode: color-dodge;"
                  />
                  <a href="tel:+91-9987099890" class="text-decoration-none"
                    >+91-9987099890</a
                  ></span
                >
                <span>
                  <img
                    src="@/assets/imgs/franchise/email_2099199.svg"
                    class="locator_pointer_img"
                    style="mix-blend-mode: color-dodge;"
                  />
                  <a class="text-decoration-none" href="mailto:info@aliff.in"
                    >info@aliff.in</a
                  ></span
                >
              </div>
            </div>
            <div></div>
          </div>
          <div class="col-lg mb-4 mb-lg-0">
            <h5 class="font-bold mb-3">Home</h5>
            <ol class="px-0 list">
              <li @click="() => $router.push({ path: '/about-us' })">
                <a>About Us</a>
              </li>
              <li @click="() => $router.push({ path: '/search/search' })">
                <a>Search</a>
              </li>
              <li @click="() => $router.push({ path: '/aliff-careers' })">
                <a>Careers</a>
              </li>
              <li @click="() => $router.push({ path: '/office-locator' })">
                <a>Contact us</a>
              </li>
            </ol>
          </div>
          <div class="col-lg mb-4 mb-lg-0">
            <h5 class="font-bold mb-3">Services</h5>
            <ol class="px-0 list">
              <li @click="() => $router.push({ path: '/career-counselling' })">
                <a>Career Counselling</a>
              </li>
              <li @click="() => $router.push({ path: '/abroad-counselling' })">
                <a>Study Abroad Counselling</a>
              </li>
              <li @click="() => $router.push({ path: '/ielts' })">
                <a>IELTS Coaching</a>
              </li>
              <li @click="() => $router.push({ path: '/aliff-premium' })">
                <a>Aliff Premium Packages</a>
              </li>
            </ol>
          </div>
          <div class="col-lg mb-4 mb-lg-0">
            <h5 class="font-bold mb-3">Resources</h5>
            <ol class="px-0 list">
              <li
                @click="
                  () =>
                    $router.push({
                      path: '/blog/foreign-education-consultants-the-steppingstone-to-successfully-studying-abroad/',
                    })
                "
              >
                <a>Aliff Blogs</a>
              </li>
              <li @click="() => $router.push({ path: '/tv-screen' })">
                <a>Aliff TV </a>
              </li>
              <li @click="() => $router.push({ path: '/sef' })">
                <a> Student Enquiry Form </a>
              </li>
              <li @click="() => $router.push({ path: '/privacy-policy' })">
                <a>Privacy Policy</a>
              </li>
              <li @click="() => $router.push({ path: '/sitemap' })">
                <a>Sitemap</a>
              </li>
            </ol>
          </div>
          <div class="col-lg mb-4 mb-lg-0">
            <h5 class="font-bold mb-3">Useful Links</h5>
            <ol class="px-0 list">
              <li
                @click="$router.push({ path: '/terms-and-services' })"
                role="button"
              >
                <a>Terms and Services</a>
              </li>
              <li @click="() => $router.push({ path: '/privacy-policy' })">
                <a>Privacy Policy</a>
              </li>
              <li
                @click="
                  () =>
                    $router.push({ path: '/cancellation-and-refund-policy' })
                "
              >
                <a>Cancellation and Refund policy</a>
              </li>
              <li @click="() => $router.push({ path: '/office-locator' })">
                <a>Office Locator</a>
              </li>
              <li @click="() => $router.push({ path: '/micro-franchise' })">
                <a>Micro Franchise</a>
              </li>
              <!-- <li @click="() => $router.push({ path: '/sitemap' })">
                <a>Sitemap</a>
              </li> -->
            </ol>
          </div>
        </div>
        <div class="footer-line mt-4 mb-4" v-if="false"></div>
        <!-- Aliff India Offices -->
        <div v-if="false">
          <h5 class="title text-center mt-5">Aliff Offices (India)</h5>
          <div class="row">
            <!-- Indian Office 1 -->
            <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/mumbai.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Bandra, Mumbai</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    ALIFF OVERSEAS, 203, God’s Gift Tower, Next To Lucky Hotel,
                    S.V. Road, Bandra (West), Mumbai – 400050, India
                  </p>
                  <a href="mailto:preeti@aliff.in" class="text-decoration-none"
                    >info@aliff.in</a
                  >
                </div>
              </div>
            </div>
            <!-- Worli -->
            <div class="col-12 col-md-6 col-lg-4">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/mumbai.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Lower Parel, Mumbai</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    Office address : 1001, 10th Floor, Marathon ICON, Opp.
                    Peninsula Corporate Park, Off, Ganapatrao Kadam Marg, Lower
                    Parel West, Mumbai, Maharashtra 400013
                  </p>
                  <a href="mailto:worli@aliff.in" class="text-decoration-none"
                    >lowerparel@aliff.in</a
                  >
                </div>
              </div>
            </div>
            <!-- Mira Road -->
            <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/mumbai.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Mira Road, Mumbai</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    C-78, Shanti Shopping Centre, Near Mira Road Station, Mira
                    Road (E), Thane 401107
                  </p>
                  <a href="mailto:preeti@aliff.in" class="text-decoration-none"
                    >preeti@aliff.in</a
                  >
                </div>
              </div>
            </div>
            <!-- Mira -->
            <!-- new -->
            <!-- Indian Office 2 -->
            <!-- <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/mumbai.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Borivali, Mumbai</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    202 Reema Terrace, Chikuwadi, Near Radhemaa Bunglow, Borivali
                    West, Mumbai 400 092
                  </p>
                  <a href="mailto:lopa@aliff.in">lopa@aliff.in</a>
                </div>
              </div>
            </div> -->
            <!-- Indian Office 3 -->
            <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/gujarat.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Vadodara, Gujarat</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    205. A WING, 2nd Floor, Siddharth Excellence, Opp Dmart
                    Store, Vasana Main Road, Vadodara 390007
                  </p>
                  <a href="" class="text-decoration-none">shabana@aliff.in</a>
                </div>
              </div>
            </div>
            <!-- Indian Office 4 -->
            <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/gujarat.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Pune, Maharashtra</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    St Crispin's Home, Second floor , Left Wing, Near Nal Stop
                    Chowk, Karve road , Pune-411004
                  </p>
                  <a href="" class="text-decoration-none">rutvij@aliff.in</a>
                </div>
              </div>
            </div>
            <!--  -->
            <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/gujarat.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Raipur, Chhattisgarh</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    Shop No 62 RDA Complex New Rajendra Nagar Raipur
                  </p>
                  <p>raipur@aliff.in</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/gujarat.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Thane, Mumbai</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    A14/604, Happy valley homes,Manpada, Thane West - 400610
                  </p>
                  <p>kajal@aliff.in</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Aliff India International -->
        <div v-if="false">
          <h5 class="title text-center mt-5">Aliff Offices (International)</h5>
          <div class="row align-items-center">
            <!-- International Office 1 -->
            <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/dubai.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Dubai</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    Al Falasi Residence, 1304 11B street, Mankhool, Dubai
                  </p>
                  <a href="mailto:dubai@aliff.in" class="text-decoration-none"
                    >dubai@aliff.in</a
                  >
                </div>
              </div>
            </div>
            <!-- International Office 2 -->
            <div class="col-12 col-md-6 col-lg-4 mb-1">
              <div class="row align-items-center">
                <div class="col-4">
                  <img
                    class="img-fluid"
                    src="@/assets/imgs/offices/kuwait.png"
                    alt=""
                  />
                  <p class="footer--office-title h5">Kuwait</p>
                </div>
                <div class="col-8">
                  <p class="footer--office-address">
                    AL-Rehab Complex, Office No. 508, floor-5, Tunis street-
                    Hawally, Kuwait.
                  </p>
                  <a href="mailto:hina@aliff.in" class="text-decoration-none"
                    >hina@aliff.in</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-between align-items-center flex-wrap mob_reponsive_gap"
      >
        <!--Social Icon Section-->

        <div class="social-icons ml-3 d-flex pt-1">
          <a href="https://www.instagram.com/aliffoverseas/" target="blank">
            <img
              src="@/assets/imgs/svgs/instagram.svg"
              class="img-fluid footer-icon"
            />
          </a>
          <a href="https://www.facebook.com/aliffoverseas/" target="blank">
            <img
              src="@/assets/imgs/svgs/facebook.svg"
              class="img-fluid footer-icon"
            />
          </a>
          <a href="https://twitter.com/aliffoverseas/" target="blank">
            <img
              src="@/assets/imgs/svgs/twitter.svg"
              class="img-fluid footer-icon"
            />
          </a>
          <a
            href="https://in.linkedin.com/company/aliffoverseas"
            target="blank"
          >
            <img
              src="@/assets/imgs/svgs/linkedin.svg"
              class="img-fluid footer-icon"
            />
          </a>
          <a href="https://www.youtube.com/aliffoverseas/" target="blank">
            <img
              src="@/assets/imgs/svgs/youtube.svg"
              class="img-fluid footer-icon"
            />
          </a>
        </div>
        <!--FeedBack Modal Section-->
        <div>
          <button
            id="feedback-button"
            v-b-popover.hover="''"
            class="float_left_button"
            v-b-modal.feedback-form-call-modal-id
          >
            Feedback / Complaints
            <!-- <i class="bi bi-chat-fill"></i> -->
            <!-- <img
              src="../../assets/imgs/customer-service-agent_3829427.png"
              alt="admin"
              width="30"
              class="rounded-cirlce"
            /> -->
          </button>

          <b-popover
            id="custom-popover-content"
            target="feedback-button"
            triggers="hover"
            placement="top"
            class="bg-dark"
          >
            <div class="d-flex align-items-center">
              <!-- <h4>Book Free Counselling</h4> -->
              <div class="text-new p-3 text-start text-light">
                <h2 class="font-weight-bold">Hi there!</h2>
                <button
                  v-b-modal.feedback-form-call-modal-id
                  class="pop-btn rounded-pill"
                >
                  Give Us Your Feedback
                </button>
              </div>
            </div>
          </b-popover>

          <b-modal
            id="feedback-form-call-modal-id"
            ref="feedback-form-call-modal-ref"
            centered
            cancel-disabled
            ok-disabled
            :hide-footer="true"
          >
            <div slot="modal-title">
              <!-- <img
                title="my-img"
                src="@/assets/imgs/student-enquiry-form/AliffLogo.png"
                alt="people"
                class="free-counselling-logo"
              /> -->
              Feedback Form
            </div>

            <form ref="form" @submit.prevent="handleSubmit">
              <div class="custom-form-control">
                <!-- <div class="form-spacing">
                  <label>Who Are You ?</label>
                  <b-form-radio-group
                    @change="onSelectIam"
                    :options="[
                      'Student',
                      'Franchise',
                      'University',
                      'Associates',
                    ]"
                    name="i_am"
                    id="footer_feedback_radio"
                    button-variant="outline-primary"
                    buttons
                  >
                  </b-form-radio-group>
                </div> -->

                <div class="form-spacing">
                  <label>Name:</label>
                  <input
                    size="sm"
                    v-model="form.name"
                    placeholder="Enter Name"
                    class="form-control"
                  />
                </div>

                <div class="form-spacing">
                  <label>Email:</label>
                  <input
                    required
                    size="sm"
                    v-model="form.email"
                    placeholder="Enter Email Address *"
                    class="form-control"
                  />
                </div>

                <div class="form-spacing">
                  <label>Phone Number:</label>
                  <input
                    size="sm"
                    v-model="form.mobileNumber"
                    placeholder="Enter Mobile Number"
                    class="form-control"
                  />
                </div>
                <div class="form-spacing">
                  <label>Message:</label>
                  <b-form-textarea
                    id="textarea"
                    v-model="form.messageData"
                    placeholder="Share Your Experience *"
                    rows="3"
                    max-rows="6"
                    required
                  ></b-form-textarea>
                </div>
                <p class="mb-0 font-weight-bold">
                  or Email directly to
                  <a href="mailto:ceo@aliff.in">ceo@aliff.in</a>
                </p>
                <div class="w-100 pt-4 d-flex justify-content-start">
                  <button
                    type="submit"
                    class="btn rounded w-50"
                    style="background-color: #fe6d01; color: white"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </b-modal>
        </div>
      </div>

      <div class="footer-line mt-4 mb-4"></div>

      <div class="d-flex justify-content-between align-items-center">
        <div>

          © 2025 Aliff, inc
        </div>
        <div>
          <img src="@/assets/imgs/usa_logo.jpg" alt="" width="100px"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
export default {
  name: "Footer",
  data() {
    return {
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
        messageData: "",
      },
      WhoAreU: "",
    };
  },
  methods: {
    onSelectIam(val) {
      this.WhoAreU = val;
    },

    formSubmitToast() {
      this.$bvToast.toast(`Your feedback has been duly noted.`, {
        title: "Feedback Sent",
        autoHideDelay: 5000,
        solid: true,
      });
    },

    async handleSubmit(e) {
      try {
        e.preventDefault();

        const formData = {
          Name: this.form.name,
          Email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          ContactNumber: this.form.mobileNumber,
          source: "feedback-form",
          WhoAreU: this.WhoAreU,
          // state: this.form.state,
          // city: this.form.city,
          messageData: this.form.messageData,
        };

        // const response = await axios.post(
        //   "https://formsubmit.co/ajax/fahadchowdhary007@gmail.com",
        //   requestData
        // );
        // console.log(response, "response");

        // axios.defaults.headers.post["Content-Type"] = "application/json";
        // axios
        //   .post(
        //     "https://formsubmit.co/ajax/fahadchowdhary007@gmail.com",
        //     requestData
        //   )
        //   .then((response) => console.log(response))
        //   .catch((error) => console.log(error));
        const response = await homeServices.sendFeedbackFormMail({
          formData,
        });

        if (response.data.status) {
          this.resetForm();
          this.formSubmitToast();
          this.$bvModal.hide("feedback-form-call-modal-id");
        }

        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },

    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      };
    },
  },
};
</script>

<style>
/* .gradient-footer {
  background: linear-gradient(135deg, #5367ff, #00d09c);
} */

.footer-icon {
  fill: white;
  width: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue